import { FormVmItemConfigType } from '../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../infrastructure/utils/form-config.utils';
import { plainText, url } from '../../../../../../modules/validators';
import { trimSpaces, trimSpacesLeft } from '../../../../../../modules/formatters';

export enum UJLFieldKey {
    ATTENDEE_ID = 'attendeeId',
    CONNECTION_LINK = 'connectionLink',
    CONNECTION_ID = 'connectionId',
    CONNECTION_PASSWORD = 'connectionPassword',
    MEETING_INVITATION = 'meetingInvitation'
}

export const FORM_CONFIG = {
    [UJLFieldKey.ATTENDEE_ID]: {
        labelDescriptor: { id: 'oe.childConnection.uniqueJoiningLink.attendeeId', defaultMessage: 'Attendee ID', description: 'Label text' },
        defaultValue: '',
    },
    [UJLFieldKey.CONNECTION_LINK]: {
        labelDescriptor: { id: 'oe.childConnection.uniqueJoiningLink.connectionLink', defaultMessage: 'Connection Link', description: 'Label text' },
        defaultValue: '',
        validators: [plainText.maxLength.medium, url.regExp],
        formatters: [trimSpaces],
    },
    [UJLFieldKey.CONNECTION_ID]: {
        labelDescriptor: { id: 'oe.childConnection.uniqueJoiningLink.connectionId', defaultMessage: 'Connection ID', description: 'Label text' },
        defaultValue: '',
    },
    [UJLFieldKey.CONNECTION_PASSWORD]: {
        labelDescriptor: { id: 'oe.childConnection.uniqueJoiningLink.connectionPassword', defaultMessage: 'Connection Password', description: 'Label text' },
        defaultValue: '',
    },
    [UJLFieldKey.MEETING_INVITATION]: {
        labelDescriptor: { id: 'oe.childConnection.uniqueJoiningLink.meetingInvitation', defaultMessage: 'Meeting Invitation', description: 'Label text' },
        defaultValue: '',
        validators: [plainText.maxLength.long],
        formatters: [trimSpacesLeft]
    },
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);